import { Dialog, DialogProps } from 'primereact/dialog'

type DialogContainerSize = 'small' | 'medium' | 'large'

const getWidthBySize = (size: DialogContainerSize) =>
    (() => {
        switch (size) {
            case 'small':
                return '22.5rem'
            case 'medium':
                return '45rem'
            case 'large':
                return '65rem'
        }
    })()

export interface DialogContainerProps extends DialogProps {
    size?: DialogContainerSize
}
export default function DialogContainer({ size, children, ...props }: DialogContainerProps) {
    size = size ?? 'small'
    return (
        <Dialog {...props} style={{ width: getWidthBySize(size) }} draggable={false}>
            {children}
        </Dialog>
    )
}
